import {MailgunLogTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function mailgunLogTypeNameFilter(type: MailgunLogTypeEnum): string {
  switch (type) {
    case MailgunLogTypeEnum.Accepted: return i18n.t(LF.AcceptedForPosting) as string;
    case MailgunLogTypeEnum.Delivered: return i18n.t(LF.Delivered) as string;
    case MailgunLogTypeEnum.Failed: return i18n.t(LF.Failed) as string;
    case MailgunLogTypeEnum.Rejected: return i18n.t(LF.Rejected) as string;
    case MailgunLogTypeEnum.Clicked: return i18n.t(LF.RecipientClickedOnLink) as string;
    case MailgunLogTypeEnum.Opened: return i18n.t(LF.Opened) as string;
    case MailgunLogTypeEnum.Stored: return i18n.t(LF.Saved) as string;
    case MailgunLogTypeEnum.Complained: return i18n.t(LF.SpamComplaint) as string;

  }
}
